<template>
  <LeftTeaser :title="title" :subtitles="subtitles" :benefits="benefits" />
</template>

<script>
import LeftTeaser from '@/components/auth/left/LeftTeaser.vue'
import { $t } from '@/composables/translation'

export default {
  name: 'LeftRegisterCompany',
  components: {
    LeftTeaser,
  },
  setup() {
    return {
      title: $t('Manage your flexible workforce'),
      subtitles: [
        $t(
          "Worksome's platform gives you full access to highly-skilled freelancers and powerful tools to help you manage your contingent workforce with ease.",
        ),
      ],
      benefits: [
        $t('Find and hire freelancers within minutes'),
        $t('Upload your existing talent pool and your recruiters'),
        $t('Generate fully compliant contracts'),
      ],
    }
  },
}
</script>
